<template>
    <div style="display: flex; width: 100%; height: 100vh;">
        <!-- 左侧：上级仓库列表（独立滚动） -->
        <div style="width: 15%; border-right: 1px solid #e6e6e6; overflow-y: auto; background: #fafafa;">
            <el-row style="margin-top: 2vh; padding: 20px;">
                <!-- 左侧搜索 + 新增上级仓库按钮 -->
                <el-col :span="24" style="margin-bottom: 20px;">
                    <el-form :inline="true" :model="parentWarehouseSearch" class="demo-form-inline"
                        style="display: flex;align-items: flex-start">
                        <el-form-item label="">
                            <el-input v-model="parentWarehouseSearch.name" placeholder="搜索仓库类型"
                                @input="filterParentWarehouses" clearable style="width: 160px;"></el-input>
                        </el-form-item>
                        <el-button type="primary" size="small" @click="showAddParentWarehouseDialog()">
                            <i class="el-icon-plus"></i> 新增仓库类型
                        </el-button>
                    </el-form>
                </el-col>

                <!-- 上级仓库列表 -->
                <el-col :span="24">
                    <div class="parent-warehouse-item" v-for="warehouse in filteredParentWarehouses"
                        :key="warehouse.houseId" :class="{ 'active': currentParentId === warehouse.houseId }"
                        @click="handleParentWarehouseClick(warehouse)">
                        <span class="parent-warehouse-name">{{ warehouse.houseName }}</span>
                        <el-button type="text" size="small"
                            @click.stop="showEditParentWarehouseDialog(warehouse)">编辑</el-button>
                        <el-button type="text" size="small" class="text-red-500"
                            @click.stop="handleDeleteParentWarehouse(warehouse)">
                            删除
                        </el-button>
                    </div>
                </el-col>
            </el-row>
        </div>


        <!-- 右侧：当前上级仓库下的子仓库列表（独立滚动） -->
        <div style="width: 85%; overflow-y: auto;">
            <el-row style="margin-top: 2vh; padding: 20px;">
                <!-- 右侧头部：当前上级仓库信息 + 操作按钮 -->
                <el-col :span="24">
                    <div
                        style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
                        <div>
                            <h3 style="margin: 0; font-size: 16px; font-weight: 700; color: #1890ff;">
                                当前上级仓库：{{ currentParentName || "未选择上级仓库" }}——共有{{ allChildWarehouses.length }}个子仓库
                            </h3>
                        </div>
                        <!-- 新增子仓库按钮（选中上级仓库才显示） -->
                        <el-button type="primary" size="small" @click="showAddChildWarehouseDialog()"
                            v-if="currentParentId">
                            <i class="el-icon-plus"></i> 新增子仓库
                        </el-button>
                    </div>

                    <!-- 子仓库搜索表单 -->
                    <el-form :inline="true" :model="childWarehouseSearch" class="demo-form-inline"
                        v-if="currentParentId">
                        <el-form-item label="仓库编号">
                            <el-input v-model="childWarehouseSearch.code" placeholder="输入编号" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="仓库名称">
                            <el-input v-model="childWarehouseSearch.name" placeholder="输入名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="loadChildWarehouses()"
                                icon="el-icon-search">查询</el-button>
                            <el-button @click="resetChildSearch()" icon="el-icon-refresh">重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!-- 子仓库列表/空状态 -->
                <el-col :span="24">
                    <!-- 未选择上级仓库 -->
                    <div class="empty-state" v-if="!currentParentId">
                        <i class="el-icon-warehouse" style="font-size: 48px; color: #ccc;"></i>
                        <p style="margin-top: 16px; color: #999;">请从左侧选择上级仓库查看子仓库列表</p>
                    </div>

                    <!-- 已选择上级仓库 -->
                    <div v-else>
                        <!-- 加载中状态 -->
                        <div class="empty-state" v-if="childWarehouseLoading">
                            <el-loading-spinner style="font-size: 48px; color: #1890ff;"></el-loading-spinner>
                            <p style="margin-top: 16px; color: #999;">正在加载子仓库数据...</p>
                        </div>

                        <!-- 子仓库为空 -->
                        <div class="empty-state" v-else-if="allChildWarehouses.length === 0">
                            <p style="margin-top: 16px; color: #999;">当前上级仓库暂无子仓库记录</p>
                            <el-button type="text" @click="showAddChildWarehouseDialog()"
                                style="margin-top: 8px; color: #1890ff;">
                                点击新增子仓库
                            </el-button>
                        </div>

                        <!-- 子仓库表格 -->
                        <el-table ref="childWarehouseTable" :data="filteredChildWarehouses" height="64vh"
                            style="width: 100%;" border :header-cell-class-name="'table-header'"
                            @row-click="handleRowClick" v-else>
                            <el-table-column type="selection" width="55" align="center" />
                            <el-table-column label="序号" type="index" width="70" align="center" />
                            <el-table-column prop="code" label="仓库编号" align="center" />
                            <el-table-column prop="houseName" label="仓库名称" align="center" />
                            <el-table-column prop="room" label="所属功能间" align="center" />
                            <el-table-column prop="address" label="仓库IP地址" align="center" />

                            <el-table-column prop="createTime" label="上传时间" align="center" />
                            <el-table-column prop="operator" label="操作员" align="center" />
                            <el-table-column label="操作" align="center" width="180">
                                <template #default="scope">
                                    <!-- <el-button type="text" size="small"
                                        @click="showEditChildWarehouseDialog(scope.row)">
                                        编辑
                                    </el-button>
                                    <el-button type="text" size="small" class="text-red-500"
                                        @click="handleDeleteChildWarehouse(scope.row.houseId)">
                                        删除
                                    </el-button> -->
                                    <el-button type="primary" icon="el-icon-edit"
                                        @click="showEditChildWarehouseDialog(scope.row)" size="small">修改</el-button>
                                    <el-button type="danger" icon="el-icon-delete"
                                        @click="handleDeleteChildWarehouse(scope.row.houseId)"
                                        size="small">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <!-- 分页（总子仓库数>0时显示） -->
                        <div style="margin-top: 20px; text-align: center;" v-if="allChildWarehouses.length > 0">
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper" :total="allChildWarehouses.length">
                            </el-pagination>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <!-- 1. 新增/编辑子仓库弹窗 -->
            <el-dialog :title="isEditChild ? '编辑子仓库' : '新增子仓库'" :visible.sync="childWarehouseDialogVisible"
                width="600px" :before-close="closeChildWarehouseDialog" :z-index="2000" append-to-body
                modal-append-to-body>
                <el-form :model="childWarehouseForm" :rules="childWarehouseRules" ref="childWarehouseFormRef"
                    label-width="120px" class="mt-4">
                    <el-form-item label="仓库编号" prop="code">
                        <el-input v-model="childWarehouseForm.code" placeholder="请输入仓库编号（如WH-2024-001）" />
                    </el-form-item>
                    <el-form-item label="仓库名称" prop="houseName">
                        <el-input v-model="childWarehouseForm.houseName" placeholder="请输入仓库名称" />
                    </el-form-item>
                    <el-form-item label="所属功能间" prop="room">
                        <el-input v-model="childWarehouseForm.room" placeholder="请输入所属功能间（如冷藏区）" />
                    </el-form-item>
                    <el-form-item label="仓库IP地址" prop="address">
                        <el-input v-model="childWarehouseForm.address" placeholder="请输入IP地址（如192.168.1.100）" />
                    </el-form-item>
                    <el-form-item label="操作员" prop="operator">
                        <el-input v-model="childWarehouseForm.operator" placeholder="操作员" />
                    </el-form-item>
                    <!-- 隐藏字段：关联上级仓库ID -->
                    <el-form-item hidden>
                        <el-input v-model="childWarehouseForm.pid" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="childWarehouseDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitChildWarehouseForm()">确定</el-button>
                </div>
            </el-dialog>

            <!-- 2. 新增/编辑上级仓库弹窗 -->
            <el-dialog :title="isEditParent ? '编辑上级仓库' : '新增上级仓库'" :visible.sync="parentWarehouseDialogVisible"
                width="500px" :before-close="closeParentWarehouseDialog" :z-index="2000" append-to-body
                modal-append-to-body>
                <el-form :model="parentWarehouseForm" :rules="parentWarehouseRules" ref="parentWarehouseFormRef"
                    label-width="120px" class="mt-4">
                    <el-form-item label="上级仓库名称" prop="houseName">
                        <el-input v-model="parentWarehouseForm.houseName" placeholder="请输入上级仓库名称（如总仓）" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="parentWarehouseDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitParentWarehouseForm()">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { addHouse, updateHouse, deleteHouse, getHouseList, getHouseListByPid } from "@/api/terminal";
export default {
    name: 'WarehouseManage',
    data() {
        return {
            // 左侧：上级仓库相关
            allParentWarehouses: [], // 所有上级仓库（从接口获取）
            filteredParentWarehouses: [], // 过滤后的上级仓库
            parentWarehouseSearch: { name: "" }, // 上级仓库搜索条件
            currentParentId: null, // 当前选中上级仓库ID (houseId)
            currentParentName: "", // 当前选中上级仓库名称
            parentWarehouseDialogVisible: false, // 上级仓库弹窗
            isEditParent: false, // 是否编辑上级仓库
            parentWarehouseForm: {
                houseId: "",  // 用于编辑时传递的ID
                houseName: ""
            }, // 上级仓库表单
            parentWarehouseRules: { // 上级仓库校验
                houseName: [{ required: true, message: "请输入上级仓库名称", trigger: "blur" }]
            },

            // 右侧：子仓库相关
            allChildWarehouses: [], // 当前上级仓库下的所有子仓库
            filteredChildWarehouses: [], // 过滤后的子仓库（搜索+分页）
            childWarehouseSearch: { code: "", name: "" }, // 子仓库搜索条件
            currentPage: 1,
            pageSize: 10,
            childWarehouseDialogVisible: false, // 子仓库弹窗
            isEditChild: false, // 是否编辑子仓库
            childWarehouseLoading: false, // 子仓库加载状态

            childWarehouseForm: { // 子仓库表单
                id: "",
                pid: "", // 关联上级仓库ID (houseId)
                code: null, // 仓库编号
                houseName: null, // 仓库名称
                room: "", // 所属功能间
                address: "", // 仓库IP地址
                operator: ''
            },
            childWarehouseRules: { // 子仓库校验
                code: [{ required: true, message: "请输入仓库编号", trigger: "blur" }],
                houseName: [{ required: true, message: "请输入仓库名称", trigger: "blur" }],
                room: [{ required: true, message: "请输入所属功能间", trigger: "blur" }],
                address: [{ required: true, message: "请输入仓库IP地址", trigger: "blur" }]
            }
        };
    },
    mounted() {
        // 初始化时从接口获取上级仓库列表
        this.fetchParentWarehouses();
    },
    methods: {
        // 从接口获取上级仓库列表（顶级仓库，parentId为空或0）
        async fetchParentWarehouses() {
            try {
                const params = {
                    userId: localStorage.getItem('userId'),
                    pid: null // 假设0表示获取顶级仓库
                };
                const response = await getHouseList(params);
                if (response.code === 200) {
                    // 假设接口返回格式: { code: 200, data: [{ houseId: 1, houseName: '总仓1' }, ...] }
                    this.allParentWarehouses = response.data || [];
                    this.filteredParentWarehouses = [...this.allParentWarehouses];
                    // 默认选中第一个上级仓库
                    if (this.allParentWarehouses.length > 0) {
                        this.handleParentWarehouseClick(this.allParentWarehouses[0]);
                    }
                } else {
                    this.$message.error("获取上级仓库列表失败：" + (response.msg || "未知错误"));
                }
            } catch (error) {
                console.error("获取上级仓库列表接口调用失败", error);
                this.$message.error("网络错误，无法获取上级仓库列表");
            }
        },

        // 左侧：上级仓库逻辑
        // 过滤上级仓库
        filterParentWarehouses() {
            const keyword = this.parentWarehouseSearch.name.trim().toLowerCase();
            this.filteredParentWarehouses = this.allParentWarehouses.filter(warehouse =>
                warehouse.houseName.toLowerCase().includes(keyword)
            );
        },

        // 点击上级仓库：加载对应子仓库
        handleParentWarehouseClick(warehouse) {
            this.currentParentId = warehouse.houseId; // 使用houseId作为标识
            this.currentParentName = warehouse.houseName;
            this.currentPage = 1;
            this.loadChildWarehouses(); // 加载子仓库数据
        },

        // 新增上级仓库弹窗
        showAddParentWarehouseDialog() {
            this.isEditParent = false;
            this.parentWarehouseForm = {
                houseId: "",
                houseName: ""
            };
            this.parentWarehouseDialogVisible = true;
            this.$nextTick(() => this.$refs.parentWarehouseFormRef?.clearValidate());
        },

        // 编辑上级仓库弹窗
        showEditParentWarehouseDialog(warehouse) {
            this.isEditParent = true;
            this.parentWarehouseForm = {
                houseId: warehouse.houseId, // 传递houseId用于编辑
                houseName: warehouse.houseName
            };
            this.parentWarehouseDialogVisible = true;
            this.$nextTick(() => this.$refs.parentWarehouseFormRef?.clearValidate());
        },

        // 提交上级仓库表单
        submitParentWarehouseForm() {
            this.$refs.parentWarehouseFormRef.validate(async (isValid) => {
                if (isValid) {
                    try {
                        if (this.isEditParent) {
                            // 编辑：调用更新接口，传递houseId
                            const params = {
                                houseId: this.parentWarehouseForm.houseId, // 关键：传递houseId
                                userId: localStorage.getItem('userId'),
                                houseName: this.parentWarehouseForm.houseName
                            };
                            const response = await updateHouse(params);
                            if (response.code === 200) {
                                this.$message.success(response.message);
                                // 重新获取列表刷新数据
                                this.fetchParentWarehouses();
                            } else {
                                this.$message.error("编辑失败：" + (response.message || "未知错误"));
                            }
                        } else {
                            // 新增：调用接口添加上级仓库（顶级仓库）
                            const params = {
                                userId: localStorage.getItem('userId'),
                                houseName: this.parentWarehouseForm.houseName,
                                pid: null // 顶级仓库parentId为0
                            };
                            const response = await addHouse(params);
                            if (response.code === 200) {
                                this.$message.success("上级仓库新增成功");
                                // 重新获取列表刷新数据
                                this.fetchParentWarehouses();
                            } else {
                                this.$message.error("新增失败：" + (response.msg || "未知错误"));
                            }
                        }
                        this.parentWarehouseDialogVisible = false;
                    } catch (error) {
                        console.error("操作上级仓库接口调用失败", error);
                        this.$message.error("网络错误，操作失败");
                    }
                }
            });
        },

        // 判断上级仓库是否有下属子仓库
        async hasChildWarehouse(parentId) {
            try {
                // 从接口获取最新的子仓库数据进行判断
                const params = {
                    userId: localStorage.getItem('userId'),
                    pid: parentId
                };
                const response = await getHouseListByPid(params);
                return response.code === 200 && Array.isArray(response.data) && response.data.length > 0;
            } catch (error) {
                console.error("检查子仓库存在性失败", error);
                return false;
            }
        },

        // 删除上级仓库（仅无下属子仓库时可删除）
        async handleDeleteParentWarehouse(warehouse) {
            const parentId = warehouse.houseId;
            const parentName = warehouse.houseName;

            // 先检查是否有子仓库
            const hasChildren = await this.hasChildWarehouse(parentId);

            if (hasChildren) {
                this.$message.warning(`"${parentName}" 下存在子仓库，请先删除所有子仓库后再删除该上级仓库`);
                return;
            }

            // 没有子仓库，执行删除操作
            this.$confirm(
                `此操作将永久删除 "${parentName}" 仓库类型，是否继续?`,
                "警告",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            ).then(async () => {
                try {
                    const params = {
                        houseId: parentId, // 传递houseId用于删除
                        userId: localStorage.getItem('userId')
                    };
                    const response = await deleteHouse(params);
                    if (response.code === 200) {
                        this.$message.success(response.message);
                        // 重新获取列表刷新数据
                        this.fetchParentWarehouses();
                        // 重置选中状态
                        if (this.currentParentId === parentId) {
                            this.currentParentId = null;
                            this.currentParentName = "";
                            this.allChildWarehouses = [];
                            this.filteredChildWarehouses = [];
                        }
                    } else {
                        this.$message.error("删除失败：" + (response.msg || "未知错误"));
                    }
                } catch (error) {
                    console.error("删除上级仓库接口调用失败", error);
                    this.$message.error("网络错误，删除失败");
                }
            }).catch(() => {
                this.$message.info("已取消删除");
            });
        },

        // 关闭上级仓库弹窗
        closeParentWarehouseDialog() {
            this.parentWarehouseDialogVisible = false;
            this.$refs.parentWarehouseFormRef?.clearValidate();
        },

        // 右侧：子仓库逻辑
        // 加载当前上级仓库的子仓库数据（通过getHouseListByPid接口，传入总仓houseId）
        async loadChildWarehouses() {
            if (!this.currentParentId) return;

            this.childWarehouseLoading = true;
            try {
                const params = {
                    userId: localStorage.getItem('userId'),
                    pid: this.currentParentId, // 关键：传入总仓的houseId获取子仓库
                    code: this.childWarehouseSearch.code,
                    houseName: this.childWarehouseSearch.name,
                };
                // 关键修改：使用getHouseListByPid接口获取子仓库列表
                const response = await getHouseListByPid(params);

                if (response.code === 200) {
                    // 假设接口返回的子仓库数据格式
                    this.allChildWarehouses = response.data || [];
                } else {
                    this.allChildWarehouses = [];
                    this.$message.error("获取子仓库列表失败：" + (response.msg || "未知错误"));
                }
                this.filterChildWarehouses();
            } catch (error) {
                console.error("获取子仓库列表接口调用失败", error);
                this.$message.error("网络错误，无法获取子仓库列表");
                this.allChildWarehouses = [];
            } finally {
                this.childWarehouseLoading = false;
            }
        },

        // 过滤子仓库（搜索+分页）
        filterChildWarehouses() {
            let filtered = [...this.allChildWarehouses];
            const { code, name } = this.childWarehouseSearch;

            if (code) filtered = filtered.filter(item => item.code && item.code.includes(code));
            if (name) filtered = filtered.filter(item => item.houseName && item.houseName.includes(name));

            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            this.filteredChildWarehouses = filtered.slice(start, end);
        },

        // 重置子仓库搜索
        resetChildSearch() {
            this.childWarehouseSearch = { code: "", name: "" };
            this.currentPage = 1;
            this.loadChildWarehouses(); // 重置后重新加载数据
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.filterChildWarehouses();
        },

        // 页码改变
        handleCurrentChange(val) {
            this.currentPage = val;
            this.filterChildWarehouses();
        },

        // 新增子仓库弹窗
        showAddChildWarehouseDialog() {
            this.isEditChild = false;
            // 初始化表单并关联当前选中的上级仓库ID
            this.childWarehouseForm = {

                pid: this.currentParentId, // 关联当前选中的上级仓库houseId
                code: null,
                houseName: null,
                room: "",
                address: "",
                operator: ''
            };
            this.childWarehouseDialogVisible = true;
            this.$nextTick(() => this.$refs.childWarehouseFormRef?.clearValidate());
        },

        // 编辑子仓库弹窗
        showEditChildWarehouseDialog(row) {
            this.isEditChild = true;
            this.childWarehouseForm = { ...row };
            this.childWarehouseDialogVisible = true;
            this.$nextTick(() => this.$refs.childWarehouseFormRef?.clearValidate());
        },

        // 提交子仓库表单（调用addHouse接口）
        submitChildWarehouseForm() {
            this.$refs.childWarehouseFormRef.validate(async (isValid) => {
                if (isValid) {
                    try {
                        // 准备提交参数
                        const params = {
                            userId: localStorage.getItem('userId'),
                            houseId: this.childWarehouseForm.houseId, // 关联上级仓库ID
                            code: this.childWarehouseForm.code,
                            houseName: this.childWarehouseForm.houseName,
                            room: this.childWarehouseForm.room,
                            address: this.childWarehouseForm.address,
                            operator: this.childWarehouseForm.operator
                        };

                        if (this.isEditChild) {

                            const response = await updateHouse(params);
                            if (response.code === 200) {
                                this.$message.success(response.message);
                                // 重新加载子仓库列表
                                this.loadChildWarehouses();
                            } else {
                                this.$message.error("编辑失败：" + (response.message || "未知错误"));
                            }
                        } else {
                            params.pid = this.currentParentId;
                            console.log(this.childWarehouseForm.houseId);

                            // 新增操作：调用addHouse接口
                            const response = await addHouse(params);
                            if (response.code === 200) {
                                this.$message.success("子仓库新增成功");
                                // 重新加载子仓库列表
                                this.loadChildWarehouses();
                            } else {
                                this.$message.error("新增失败：" + (response.msg || "未知错误"));
                            }
                        }
                        this.childWarehouseDialogVisible = false;
                    } catch (error) {
                        console.error("操作子仓库接口调用失败", error);
                        this.$message.error("网络错误，操作失败");
                    }
                }
            });
        },

        // 删除子仓库（调用deleteHouse接口）
        handleDeleteChildWarehouse(houseId) {
            this.$confirm(
                `此操作将永久删除该子仓库记录，是否继续?`,
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            ).then(async () => {
                try {
                    const params = {
                        houseId: houseId, // 子仓库ID
                        userId: localStorage.getItem('userId')
                    };
                    const response = await deleteHouse(params);
                    if (response.code === 200) {
                        this.$message.success(response.message);
                        // 重新加载子仓库列表
                        this.loadChildWarehouses();
                    } else {
                        this.$message.error("删除失败：" + (response.msg || "未知错误"));
                    }
                } catch (error) {
                    console.error("删除子仓库接口调用失败", error);
                    this.$message.error("网络错误，删除失败");
                }
            }).catch(() => {
                this.$message.info("已取消删除");
            });
        },

        // 关闭子仓库弹窗
        closeChildWarehouseDialog() {
            this.childWarehouseDialogVisible = false;
            this.$refs.childWarehouseFormRef?.clearValidate();
        },

        // 表格行点击选中
        handleRowClick(row) {
            this.$refs.childWarehouseTable?.toggleRowSelection(row);
        }
    }
};
</script>

<style lang="scss" scoped>
/* 左侧上级仓库样式 */
.parent-warehouse-item {
    padding: 12px 16px;
    margin-bottom: 8px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    color: #333;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
        background-color: #f5f7fa;
    }

    &.active {
        background: #e6f7ff;
        border-right: 3px solid #1890ff;
        color: #1890ff;
        font-weight: 500;
    }
}

/* 空状态样式 */
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 240px);
    color: #999;
}

/* 表格头部样式 */
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

/* 文本颜色 */
.text-red-500 {
    color: #f56c6c;
}

/* 表单样式 */
.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
}

/* 弹窗层级修复 */
::v-deep .el-dialog__wrapper {
    z-index: inherit !important;
}
</style>